module.exports = __webpack_public_path__ + "img/luza4.39c20910.jpeg";